import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sideBar :{
        pays: "",
        region: "",
        commune: "",
        dateDebut: "",
        dateFin: "",
        budget: 100 ,
        restitution:[],
        kilometrage:[],
        type: [],
        conditions: [],
        equipement: [],
      },
      kilosMax:30,
      kilosMin : 750,
      budget : 100,
  url: "",
  redirect:false,
  responseCarsLocation: []
};

export const sbCarsLocationSlice = createSlice({
  name: "sbcarsLocationSlice",
  initialState,
  reducers: {
    sideBarLocation: (state, action) => {
      state.sideBar = action.payload;
      //create url with params to be pushed
      state.url = Object.entries(state.sideBar).filter(([key, val]) => val != null && val != "").map(([key, val]) => `${key}=${val}`).join('&').replaceAll(' ',"+")
      state.redirect = true
    },
    redirect:(state, action)=>{
      state.redirect = action.payload
    },
    searchedLocation:(state,action)=>{
      state.responseCarsLocation = action.payload
    }
    },
});
export const { sideBarLocation , redirect, searchedLocation} = sbCarsLocationSlice.actions;

export default sbCarsLocationSlice.reducer;
